import { createAction, props } from '@ngrx/store';
import { PaginationState } from '@shared/models/pagination-state';
import { Sorting } from '@shared/models/sorting';
import { OpportunityFilters } from '@shared/models/opportunity-filters';
import { Opportunity } from '@shared/models/opportunity';

export const loadOpportunities = createAction(
  '[Opportunities] Load Opportunities',
  props<{ filters: OpportunityFilters; paginationState: PaginationState; sorting: Sorting }>(),
);

export const loadOpportunitiesSuccess = createAction(
  '[Opportunities] Load Opportunities Success',
  props<{ opportunities: Opportunity[]; paginationState: PaginationState }>(),
);

export const loadOpportunitiesFailure = createAction(
  '[Opportunities] Load Opportunities  Failure',
  props<{ error: any }>(),
);
